<div class="game-overlay" *ngIf="phase !== GamePhase.IDLE" [@slideUp]
     [class.lb-open]="isLeaderboardOpen && phase === GamePhase.MINI_GAME_ACTIVE && currentGameType !== MiniGameType.TUG_OF_WAR && currentGameType !== MiniGameType.SYMMETRY && currentGameType !== MiniGameType.MATCH_UP && currentGameType !== MiniGameType.FRACTION_LINE && currentGameType !== MiniGameType.FRACTION_HOPS && currentGameType !== MiniGameType.FRACTION_TREK && currentGameType !== MiniGameType.ZOOM_QUEST && currentGameType !== MiniGameType.TREASURE_GRID && currentGameType !== MiniGameType.CUBE_FILL && currentGameType !== MiniGameType.BALANCE_IT && currentGameType !== MiniGameType.POWER_BURST && currentGameType !== MiniGameType.CUTTING_PIZZA && currentGameType !== MiniGameType.VAULT_CRACKER">
  <!-- Top bar (back button — only during active games, summary, quiz) -->
  <div class="game-top-bar" *ngIf="showBackButton">
    <button class="back-btn" (click)="closeGame()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ currLang === 'ar' ? 'العودة لشاشة النداء' : 'Back to Calling Screen' }}</span>
    </button>
  </div>

  <!-- Select Game button (bottom-left, visible during active gameplay) -->
  <button class="select-game-btn" *ngIf="showGameHeader && !showPreGameCountdown" (click)="onSelectGame()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="white" stroke-width="2"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="white" stroke-width="2"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="white" stroke-width="2"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="white" stroke-width="2"/>
    </svg>
    <span>{{ currLang === 'ar' ? 'اختيار اللعبة' : 'Select Game' }}</span>
  </button>

  <!-- Dismissal Interrupt Banner -->
  <app-dismissal-interrupt></app-dismissal-interrupt>

  <!-- Class Selection -->
  <app-class-select *ngIf="phase === GamePhase.CLASS_SELECT"></app-class-select>

  <!-- Student Loading -->
  <app-student-loading *ngIf="phase === GamePhase.STUDENT_LOADING"></app-student-loading>

  <!-- Game Hub -->
  <app-game-hub *ngIf="phase === GamePhase.HUB"></app-game-hub>

  <!-- Game Category Picker (Trivia / Fun Games) — top-level manual pick -->
  <app-game-category-picker *ngIf="phase === GamePhase.GAME_CATEGORY"></app-game-category-picker>

  <!-- Fun Games Picker — Bowling + "more coming soon" placeholder -->
  <app-fun-games-picker *ngIf="phase === GamePhase.FUN_GAMES_PICK"></app-fun-games-picker>

  <!-- Academic Skill Games — subject picker, then that subject's games -->
  <app-academic-subject-picker *ngIf="phase === GamePhase.ACADEMIC_SUBJECT_PICK"></app-academic-subject-picker>
  <app-academic-games-picker *ngIf="phase === GamePhase.ACADEMIC_GAMES_PICK"></app-academic-games-picker>

  <!-- Subject Picker (reached from Trivia category) -->
  <app-subject-picker *ngIf="phase === GamePhase.SUBJECT_PICK"></app-subject-picker>

  <!-- Game Selector -->
  <app-game-selector *ngIf="phase === GamePhase.GAME_SELECT"></app-game-selector>

  <!-- Team Setup (Tug of War) -->
  <app-tug-of-war-team-setup *ngIf="phase === GamePhase.TEAM_SETUP && currentGameType === MiniGameType.TUG_OF_WAR"></app-tug-of-war-team-setup>

  <!-- Bowling Setup (1v1 or Team vs Team) -->
  <app-bowling-setup *ngIf="phase === GamePhase.TEAM_SETUP && currentGameType === MiniGameType.BOWLING"></app-bowling-setup>

  <!-- Pre-game countdown -->
  <div class="pre-game-countdown" *ngIf="showPreGameCountdown && phase === GamePhase.MINI_GAME_ACTIVE">
    <ng-container *ngIf="countdownAnimating">
      <!-- Radial burst lines -->
      <div class="burst-container">
        <div class="burst-line" *ngFor="let b of burstLines" [style.--angle]="b + 'deg'"></div>
      </div>

      <!-- Shockwave rings -->
      <div class="shockwave ring-1" [class.fire]="preGameCountdownValue <= 2"></div>
      <div class="shockwave ring-2" [class.fire]="preGameCountdownValue <= 2"></div>
      <div class="shockwave ring-3"></div>

      <!-- Floating particles -->
      <div class="particles">
        <div class="particle" *ngFor="let p of particles"
             [style.--px]="p.x" [style.--py]="p.y"
             [style.--delay]="p.delay + 'ms'"
             [style.--size]="p.size + 'px'"
             [style.--color]="p.color">
        </div>
      </div>

      <!-- The number -->
      <div class="countdown-stage">
        <div class="countdown-number">
          <span class="num-main">{{ preGameCountdownValue | arabicNumber:currLang }}</span>
          <span class="num-ghost">{{ preGameCountdownValue | arabicNumber:currLang }}</span>
          <span class="num-ghost num-ghost-2">{{ preGameCountdownValue | arabicNumber:currLang }}</span>
        </div>
        <div class="countdown-label" *ngIf="preGameCountdownValue === 3">
          {{ currLang === 'ar' ? 'استعد' : 'GET READY' }}
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Mini-Games -->
  <ng-container *ngIf="phase === GamePhase.MINI_GAME_ACTIVE && !showPreGameCountdown">
    <app-spin-wheel-game *ngIf="currentGameType === MiniGameType.SPIN_WHEEL"></app-spin-wheel-game>
    <app-tug-of-war-game *ngIf="currentGameType === MiniGameType.TUG_OF_WAR"></app-tug-of-war-game>
    <app-lightning-round-game *ngIf="currentGameType === MiniGameType.LIGHTNING_ROUND"></app-lightning-round-game>
    <app-bomb-pass-game *ngIf="currentGameType === MiniGameType.BOMB_PASS"></app-bomb-pass-game>
    <app-mystery-box-game *ngIf="currentGameType === MiniGameType.MYSTERY_BOX"></app-mystery-box-game>
    <app-bowling-game *ngIf="currentGameType === MiniGameType.BOWLING"></app-bowling-game>
    <app-symmetry-game *ngIf="currentGameType === MiniGameType.SYMMETRY"></app-symmetry-game>
    <app-match-up-game *ngIf="currentGameType === MiniGameType.MATCH_UP"></app-match-up-game>
    <app-fraction-line-game *ngIf="currentGameType === MiniGameType.FRACTION_LINE"></app-fraction-line-game>
    <app-fraction-hops-game *ngIf="currentGameType === MiniGameType.FRACTION_HOPS"></app-fraction-hops-game>
    <app-fraction-trek-game *ngIf="currentGameType === MiniGameType.FRACTION_TREK"></app-fraction-trek-game>
    <app-zoom-quest-game *ngIf="currentGameType === MiniGameType.ZOOM_QUEST"></app-zoom-quest-game>
    <app-treasure-grid-game *ngIf="currentGameType === MiniGameType.TREASURE_GRID"></app-treasure-grid-game>
    <app-cube-fill-game *ngIf="currentGameType === MiniGameType.CUBE_FILL"></app-cube-fill-game>
    <app-balance-it-game *ngIf="currentGameType === MiniGameType.BALANCE_IT"></app-balance-it-game>
    <app-power-burst-game *ngIf="currentGameType === MiniGameType.POWER_BURST"></app-power-burst-game>
    <app-cutting-pizza-game *ngIf="currentGameType === MiniGameType.CUTTING_PIZZA"></app-cutting-pizza-game>
    <app-vault-cracker-game *ngIf="currentGameType === MiniGameType.VAULT_CRACKER"></app-vault-cracker-game>

    <!-- Live Leaderboard overlay (not for team games / self-paced skill games) -->
    <app-live-leaderboard *ngIf="currentGameType !== MiniGameType.TUG_OF_WAR && currentGameType !== MiniGameType.BOWLING && currentGameType !== MiniGameType.SYMMETRY && currentGameType !== MiniGameType.MATCH_UP && currentGameType !== MiniGameType.FRACTION_LINE && currentGameType !== MiniGameType.FRACTION_HOPS && currentGameType !== MiniGameType.FRACTION_TREK && currentGameType !== MiniGameType.ZOOM_QUEST && currentGameType !== MiniGameType.TREASURE_GRID && currentGameType !== MiniGameType.CUBE_FILL && currentGameType !== MiniGameType.BALANCE_IT && currentGameType !== MiniGameType.POWER_BURST && currentGameType !== MiniGameType.CUTTING_PIZZA && currentGameType !== MiniGameType.VAULT_CRACKER"></app-live-leaderboard>
  </ng-container>

  <!-- Mini-Game Summary -->
  <app-mini-game-summary *ngIf="phase === GamePhase.MINI_GAME_SUMMARY"></app-mini-game-summary>

  <!-- Phase 2: Creature Picker (hidden for Phase 1)
  <app-creature-picker *ngIf="phase === GamePhase.CREATURE_PICK"></app-creature-picker>
  -->

  <!-- Phase 2: Creature Profile (hidden for Phase 1)
  <app-creature-profile *ngIf="phase === GamePhase.CREATURE_PROFILE"></app-creature-profile>
  -->

  <!-- Quiz -->
  <app-quiz-container *ngIf="phase === GamePhase.QUIZ"></app-quiz-container>

  <!-- Quiz Result (per question) -->
  <app-quiz-result *ngIf="phase === GamePhase.QUIZ_RESULT"></app-quiz-result>

  <!-- Quiz Summary (end of session) -->
  <app-quiz-summary *ngIf="phase === GamePhase.QUIZ_SUMMARY"></app-quiz-summary>

  <!-- Phase 2: School Map (hidden for Phase 1)
  <app-school-map *ngIf="phase === GamePhase.MAP"></app-school-map>
  -->
</div>
